export default __webpack_public_path__ + "static/media/shift-arrow.b42bebd4.svg";